import { network } from 'services/network';

export const trackUntrackItems = (params) => {
    return network.post('api/bo/trackUntrackItems', params).then((response) => {
        return response.data;
    });
};
